import { CommissioningStatusEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { StatusAvailabilityContext, StatusRuleSet } from '../status-availability.model';

/**
 * Gas: Der Schornsteinfeger wird nur angefragt, wenn eine Anlagenänderung erfasst werden kann (Abfrage
 * sichtbar oder per Default gesetzt) und er bestätigen muss (`chimneySweepAcceptance` fehlt oder
 * `ACCEPTANCE`).
 */
const chimneySweepConfirmationReachable = (ctx: StatusAvailabilityContext): boolean => {
  const gas = ctx.config.commissioning?.gasConfig;
  const installationChangePossible =
    !!gas?.installationHasChangedVisible || !!gas?.installationHasChangedDefault;
  return installationChangePossible && gas?.chimneySweepAcceptance !== 'INFORMATION';
};

const subjectToFeeProcess = (ctx: StatusAvailabilityContext): boolean =>
  !!ctx.config.commissioning?.activateSubjectToFeeProcess;

const technicalReviewProcess = (ctx: StatusAvailabilityContext): boolean =>
  !!ctx.config.commissioning?.activateTechnicalReviewProcess;

/** Inbetriebnahme: Status, die nicht jeder Mandant über einen Prozessschritt erreicht. */
export const COMMISSIONING_STATUS_RULES: StatusRuleSet = {
  blacklist: {
    [CommissioningStatusEnum.ChimneySweepConfirmationRequested]: chimneySweepConfirmationReachable,
    [CommissioningStatusEnum.FeedbackNeededByChimneySweep]: chimneySweepConfirmationReachable,
    [CommissioningStatusEnum.InstallationCompleted]: (ctx) =>
      !!ctx.config.commissioning?.gasConfig?.activateTechnicianCompletionStep ||
      !!ctx.config.commissioning?.waterConfig?.activateTechnicianCompletionStep,
    [CommissioningStatusEnum.DefectReported]: (ctx) => !!ctx.config.commissioning?.reportDefectActive,
    [CommissioningStatusEnum.WaitingForOrder]: subjectToFeeProcess,
    [CommissioningStatusEnum.Commissioned]: subjectToFeeProcess,
    [CommissioningStatusEnum.TechnicalReview]: technicalReviewProcess,
    [CommissioningStatusEnum.NAVSent]: technicalReviewProcess,
    [CommissioningStatusEnum.ReadyToApprove]: null,
    [CommissioningStatusEnum.PendingAppointment]: null,
    [CommissioningStatusEnum.Error]: null,
    [CommissioningStatusEnum.Cancelled]: null,
    [CommissioningStatusEnum.UnderReview]: null,
    [CommissioningStatusEnum.ReviewCompleted]: null
  }
};
